import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  TextField,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  Tabs,
  Tab
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./MapParameter.css"; // Using your existing CSS
import apiService from "../../utils/apiservice";



const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const MapEngineerToSupervisor = () => {
  const [supervisors, setSupervisors] = useState([]);
  const [selectedSupervisor, setSelectedSupervisor] = useState("");
  const [availableEngineers, setAvailableEngineers] = useState([]);
  const [assignedEngineers, setAssignedEngineers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);



  const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(5);

// Reset page when switching tabs or changing the supervisor
useEffect(() => {
  setPage(0);
}, [tabValue, selectedSupervisor]);

const handleChangePage = (event, newPage) => setPage(newPage);
const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
};
  // ✅ CONSTANT HEADER CONFIGURATION
  const getConfig = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: {},
  });

  const fetchSupervisors = async () => {
    try {
      const customerId = localStorage.getItem("customer_id");
      // const res = await axios.get(
      //   `${API_URL}/api/get_supervisors/${customerId}/`, 
      //   getConfig()
      // );
      const res = await apiService.get(`/api/get_supervisors/${customerId}/`, {
      data: {} // ✅ explicitly adding empty data object
    });
      const data = res.data.supervisors || [];
      setSupervisors(data);
      if (data.length > 0) {
        setSelectedSupervisor(data[0].id?.id || data[0].user_id);
        fetchTeamData(data[0].id || data[0].user_id);
      }
    } catch (err) {
      toast.error("Failed to fetch supervisors");
    }
  };

 const fetchTeamData = async (supervisorId) => {
  try {
    setLoading(true);

    const customerId = localStorage.getItem("customer_id");

    const res = await axios.get(
      `${API_URL}/api/get_engineers/${customerId}/`,
      getConfig()
    );

    const allEngineers = res.data.engineers || [];

    // ✅ Assigned Engineers (belong to selected supervisor)
    const assigned = allEngineers
      .filter(
        (eng) =>
          eng.parentSupervisor &&
          eng.parentSupervisor !== "Unassigned"
      )
      .map((eng) => ({
        user_id: eng.id.id,
        first_name: eng.firstName,
        last_name: eng.lastName,
        isAssigned: true,
      }));

    // ✅ Available Engineers (no supervisor)
    const available = allEngineers
      .filter(
        (eng) =>
          !eng.parentSupervisor ||
          eng.parentSupervisor === "Unassigned"
      )
      .map((eng) => ({
        user_id: eng.id.id,
        first_name: eng.firstName,
        last_name: eng.lastName,
        isAssigned: false,
      }));

    setAssignedEngineers(assigned);
    setAvailableEngineers(available);

  } catch (err) {
    console.error(err);
    toast.error("Failed to fetch engineers");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => { fetchSupervisors(); }, []);

  const handleSupervisorChange = (e) => {
    const id = e.target.value;
    setSelectedSupervisor(id);
    fetchTeamData(id);
  };

  const handleAction = async (engineer, action) => {
    const isAssigning = action === 'assign';
    const endpoint = isAssigning ? 'assign_engineer_to_supervisor' : 'unassign_engineer_from_supervisor';
    
    // Payload preparation
   // ✅ FIXED PAYLOAD
  const payload = isAssigning 
    ? { 
        supervisor_id: typeof selectedSupervisor === "object" 
          ? selectedSupervisor.id 
          : selectedSupervisor,
        engineer_id: engineer.user_id 
      }
    : { engineer_id: engineer.user_id };

  console.log("FINAL PAYLOAD:", payload); // 🔍 DEBUG

    try {
      await axios.post(
        `${API_URL}/api/${endpoint}/`, 
        payload,
        getConfig() 
      );

      if (isAssigning) {
        setAssignedEngineers([...assignedEngineers, { ...engineer, isAssigned: true }]);
        setAvailableEngineers(availableEngineers.filter(e => e.user_id !== engineer.user_id));
      } else {
        setAvailableEngineers([...availableEngineers, { ...engineer, isAssigned: false }]);
        setAssignedEngineers(assignedEngineers.filter(e => e.user_id !== engineer.user_id));
      }
      toast.success(`Engineer ${isAssigning ? 'assigned' : 'unassigned'} successfully`);
    } catch (err) {
      toast.error(err.response?.data?.error || "Action failed");
    }
  };

  const getFilteredData = () => {
    if (tabValue === 1) return assignedEngineers;
    if (tabValue === 2) return availableEngineers;
    // Tab "All" returns the merged list of both (Matches your Image logic)
    return [...assignedEngineers, ...availableEngineers];
  };

  return (
    <>
      <Paper className="main-card-ui">
        <Box className="header-row">
          <TextField
            select
            label="Select Supervisor"
            value={selectedSupervisor}
            onChange={handleSupervisorChange}
            size="small"
            className="device-select-input"
          >
            {supervisors.map((sup) => (
              <MenuItem key={sup.id.id} value={sup.id.id}>
                {sup.firstName ? `${sup.firstName} ${sup.lastName}` : `${sup.first_name} ${sup.last_name}`}
              </MenuItem>
            ))}
          </TextField>

          <Box className="badge-container">
            <div className="status-badge assigned">Assigned: {assignedEngineers.length}</div>
            <div className="status-badge available">Available: {availableEngineers.length}</div>
          </Box>
        </Box>

        <Box className="tabs-wrapper">
          <Tabs 
            value={tabValue} 
            onChange={(e, v) => setTabValue(v)} 
            centered 
            className="custom-tabs"
            TabIndicatorProps={{ style: { display: 'none' } }}
          >
            <Tab label="All" />
            <Tab label="Assigned" />
            <Tab label="Available" />
          </Tabs>
        </Box>

        <TableContainer className="table-container-ui orange-table">
          {loading ? (
            <Box textAlign="center" p={5}><CircularProgress /></Box>
          ) : (
           <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Engineer Name</TableCell>
                  {/* <TableCell>User ID</TableCell> */}
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getFilteredData().length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center" style={{ padding: '20px', color: '#94a3b8' }}>
                      No engineers found for this selection.
                    </TableCell>
                  </TableRow>
                ) : (
                  getFilteredData().slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  .map((row) => (
                    <TableRow key={row.user_id}>
                      <TableCell align="center">{row.first_name} {row.last_name}</TableCell>
                      {/* <TableCell className="code-text">{row.user_id}</TableCell> */}
                      <TableCell align="center">
                        {row.isAssigned ? (
                          <Button className="btn-unmap" onClick={() => handleAction(row, 'unassign')}>Unassign</Button>
                        ) : (
                          <Button className="btn-map" onClick={() => handleAction(row, 'assign')}>Assign</Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          )}


          {/* After </TableContainer> */}
{!loading && getFilteredData().length > 0 && (
  <div className="pagination-bar">
    <div className="rows-select">
      Rows per page:
      <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
        <option value={5}>5</option>
        <option value={10}>10</option>
        <option value={25}>25</option>
      </select>
    </div>
    <div className="page-info">
      {page * rowsPerPage + 1}-
      {Math.min((page + 1) * rowsPerPage, getFilteredData().length)} of {getFilteredData().length}
    </div>
    <div className="page-arrows">
      <button disabled={page === 0} onClick={() => setPage(page - 1)}>‹</button>
      <button 
        disabled={(page + 1) * rowsPerPage >= getFilteredData().length} 
        onClick={() => setPage(page + 1)}
      >
        ›
      </button>
    </div>
  </div>
)}
        </TableContainer>
      </Paper>
      <ToastContainer position="top-right" autoClose={2000} />
    </>
  );
};

export default MapEngineerToSupervisor;